import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";

import Nav from "react-bootstrap/Nav"
import Navbar from "react-bootstrap/Navbar"
import Button from "react-bootstrap/Button";
import NavDropdown from 'react-bootstrap/NavDropdown';
import "./nav.scss"

import { loginRequest } from "../../authConfig";

export const NavigationBar = () => {

    const { instance,accounts } = useMsal();

    /**
     * Most applications will need to conditionally render certain components based on whether a user is signed in or not. 
     * msal-react provides 2 easy ways to do this. AuthenticatedTemplate and UnauthenticatedTemplate components will 
     * only render their children if a user is authenticated or unauthenticated, respectively.
     */
    return (
        <>
            <Navbar bg="primary" variant="dark" className="foreclosure-editor-nav">
                <Navbar.Brand href="/#/admin">Foreclosure Editor</Navbar.Brand>
                <AuthenticatedTemplate>
                    <Nav className="ms-auto">
                        <NavDropdown title={accounts[0]?.name} id="nav-dropdown" align="end">
                            <NavDropdown.Item onClick={() => instance.logoutRedirect({ postLogoutRedirectUri: "/" })}>Sign Out</NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                    <Nav className="ms-auto">
                        <Nav.Link as={Button} variant="secondary" className="d-none" onClick={() => instance.loginRedirect(loginRequest)}>Sign in</Nav.Link>
                    </Nav>
                </UnauthenticatedTemplate>
            </Navbar>
        </>
    );
};